<template>
    <vxe-modal
        v-model="formInput.isShow"
        :title="formInput.title"
        width="840"
        height="300"
        @close="closeReqEvent"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                :rules="formInput.formRules"
                title-align="right"
                ref="rForm"
                title-width="60"
            >
                <vxe-form-item
                    title="课程名称"
                    field="course_name"
                    span="20"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.course_name"
                            placeholder="课程名称"
                            :disabled="allInputDisable"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" field="" span="4">
                    <a href="javascript:void(0);" @click="downloadFile">模板</a>
                </vxe-form-item>
                <vxe-form-item
                    title="报名数据"
                    field="fPath"
                    span="20"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.fPath"
                            placeholder="请选择报名数据文件"
                            :disabled="allInputDisable"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="4">
                    <template #default>
                        <vxe-button
                            @click="insertFileEvent"
                            :disabled="allInputDisable || uploading"
                            >浏览</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" field="" span="24">
                    <div>
                        注：可用于导入由学习发展科提供的培训签到名单（是全量导入，会覆盖原有数据，请谨慎操作）。
                    </div>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer>
            <div style="text-align: center; width: 100%">
                <vxe-button
                    @click="save"
                    icon="fa fa-save"
                    status="success"
                    :loading="uploading"
                >
                    导入
                </vxe-button>
                <vxe-button
                    icon="fa fa-close"
                    @click="formInput.isShow = false"
                    status="primary"
                    >取消</vxe-button
                >
            </div>
        </template>
    </vxe-modal>
</template>
<script setup>
import {
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
const { proxy } = getCurrentInstance();
const emit = defineEmits(["flashList"]);
const formInput = reactive({
    title: "导入培训签到清单",
    isShow: false,
    formData: {
        id: "",
        course_name: "",
        fPath: "",
        saveButDisable: false,
        submitBtnDisable: false,
    },
    formRules: {
        course_name: [{ required: true, message: "课程名称不能为空" }],
        fPath: [{ required: true, message: "请选择报名数据文件" }],
    },
});
const rForm = ref(null);
let oneFile = ref(null); //上传的附件
let uploading = ref(false); //上传状态
let allInputDisable = ref(false); //是否禁用输入

const openModal = async (row) => {
    formInput.formData = {
        id: row.id || "",
        course_name: row.course_name || "",
        fPath: "",
    };

    formInput.title = "导入培训签到清单";
    formInput.isShow = true;
    allInputDisable.value = false;
    const $rForm = rForm.value;

    try {
        if ($rForm) {
            await $rForm.reset();
        }
    } catch (e) {
        console.log(e);
    }
    oneFile.value = null;
};

const insertFileEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        // 文件格式验证
        const validTypes = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        if (!validTypes.includes(file.type)) {
            VXETable.modal.message({
                content: "请上传 Excel 文件（.xlsx 或 .xls）",
                status: "error",
            });
            return;
        }
        // 文件大小验证（5MB）
        if (file.size > 5 * 1024 * 1024) {
            VXETable.modal.message({
                content: "文件大小不能超过 5MB",
                status: "error",
            });
            return;
        }
        formInput.formData.fPath = file.name;
        oneFile.value = file;
    });
};

const downloadFile = () => {
    proxy.$api.fileManageAPI
        .downloadPublishFile(
            Qs.stringify({
                publishId: "1",
                type: "9",
            })
        )
        .then(async (res) => {
            const contentType = res.headers["content-type"] || "";

            // 后端返回错误JSON
            if (contentType.includes("application/json")) {
                const text = await res.data.text();

                try {
                    const result = JSON.parse(text);

                    VXETable.modal.alert({
                        content: result.Message || "下载失败",
                        status: "error",
                    });
                } catch (e) {
                    VXETable.modal.alert({
                        content: text,
                        status: "error",
                    });
                }

                return;
            }

            let fileName = "课程培训签到数据导入模板.xlsx";

            const disposition =
                res.headers["content-disposition"] ||
                res.headers["Content-Disposition"];

            if (disposition) {
                const utf8Match = disposition.match(
                    /filename\*=UTF-8''([^;]+)/i
                );

                const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (normalMatch && normalMatch[1]) {
                    fileName = decodeURIComponent(normalMatch[1]);
                }
            }

            const blob = new Blob([res.data], {
                type: contentType || "application/octet-stream",
            });

            if (blob.size === 0) {
                VXETable.modal.alert({
                    content: "文件内容为空",
                    status: "error",
                });
                return;
            }

            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.style.display = "none";

            document.body.appendChild(a);

            a.click();

            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.error(error);

            VXETable.modal.alert({
                content: "文件下载失败",
                status: "error",
            });
        });
};

const save = async () => {
    const $rForm = rForm.value;
    try {
        await $rForm.validate();
    } catch (e) {
        return;
    }

    // 验证文件
    if (!oneFile.value) {
        VXETable.modal.message({
            content: "请选择报名数据文件",
            status: "error",
        });
        return;
    }

    uploading.value = true;

    const formData = new FormData();
    formData.append("file", oneFile.value);
    formData.append("course_id", formInput.formData.id);
    formData.append("creator", proxy.$store.state.userID);

    proxy.$api.courseManageAPI
        .importCourseSignIn(formData)
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }

            // 显示导入结果
            const result = res.data.Data;
            const message =
                result && result.successCount !== undefined
                    ? `导入成功！共导入 ${result.successCount} 条记录${
                          result.failCount > 0
                              ? `，失败 ${result.failCount} 条`
                              : ""
                      }`
                    : "导入成功";
            VXETable.modal.message({
                content: message,
                status: "success",
            });

            formInput.isShow = false;
            emit("flashList");
        })
        .catch((error) => {
            VXETable.modal.alert({ content: error, status: "error" });
            console.log(error);
        })
        .finally(() => {
            uploading.value = false;
        });
};

const closeReqEvent = () => {
    emit("flashList");
};

defineExpose({ openModal });
</script>
<style scoped></style>
